import React from 'react';

import { Appointment } from '~weekly-planner/lib/common';

import { DOCUMENT_TYPES } from '~constants/common';

import { useToast } from '~libs/toast';

import { AsyncActionIcon } from '~components';
import { faFilePdf } from '~components/icon';

import { useDocumentBatchGeneration } from '~main/components/document-batch-jobs/useDocumentBatchGeneration';

interface ComponentProps {
  appointment: Appointment | null;
  color?: string;
}

export const ExportToPDFButton: React.FC<ComponentProps> = ({ appointment, color }) => {
  const { generateSeparate, isGenerating } = useDocumentBatchGeneration();
  const { showToast } = useToast();
  const iconColor = color ?? 'black';

  const handleGeneratePdf = async () => {
    try {
      await generateSeparate(DOCUMENT_TYPES.APPOINTMENT.PDF, [String(appointment?.id ?? '')]).unwrap();
      showToast('success', 'Appointment PDF generation started — check Document Batch Jobs when ready');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to start appointment PDF generation';
      showToast('danger', message);
      console.error('Appointment PDF generation failed:', error);
      throw error;
    }
  };

  return (
    <AsyncActionIcon
      id="export-appointment-pdf-icon"
      icon={faFilePdf}
      toolTip="Export To PDF"
      color={iconColor}
      onClick={handleGeneratePdf}
      disabled={isGenerating || !appointment?.id}
      successTitle="Appointment PDF generation started"
      spinnerDataCy="appointment-generate-pdf-spinner"
    />
  );
};

export default ExportToPDFButton;
